const api = {
  key: "kwbyqq3VlUfx9c8DGb7YqA3a2E2C1iJ2xWgrtSmC",
};

export default api;
